<template>
  <van-popup
    v-model="visible"
    round
    position="bottom"
    closeable
    style="height: 70vh"
  >
    <div class="policy-container">
      <van-tabs sticky animated>
        <van-tab title="行李额规定">
          <van-skeleton :row="5" :loading="baggageLoading">
            <div v-if="baggageDatas" class="policy-content">
              <div
                class="flight-baggage-item"
                v-if="baggageDatas.checkedBaggageRule"
              >
                <span class="flight-baggage-title">免费行李规定：</span>
                <span class="flight-baggage-content">{{
                  baggageDatas.checkedBaggageRule
                }}</span>
              </div>
              <div
                class="flight-baggage-item"
                v-if="baggageDatas.cabinBaggageRule"
              >
                <span class="flight-baggage-title">随身行李规定：</span>
                <span class="flight-baggage-content">{{
                  baggageDatas.cabinBaggageRule
                }}</span>
              </div>
              <div
                class="flight-baggage-item"
                v-if="baggageDatas.infantBaggageRule"
              >
                <span class="flight-baggage-title">婴儿免费行李规定：</span>
                <span class="flight-baggage-content">{{
                  baggageDatas.infantBaggageRule
                }}</span>
              </div>
              <div class="flight-baggage-item" v-if="baggageDatas.specialRules">
                <span class="flight-baggage-title">特殊票务说明：</span>
                <div
                  class="flight-baggage-content"
                  v-for="(item, index) in baggageDatas.specialRules"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div v-else class="empty-data">暂无数据</div>
          </van-skeleton>
        </van-tab>
        <van-tab title="退改签规则">
          <van-skeleton :row="5" :loading="tgqLoading">
            <div v-if="tgqDatas" class="policy-content">
              <div class="tgq-table">
                <div
                  class="tgq-table-body"
                  v-for="(item, i) in tgqDatas.data"
                  :key="i"
                >
                  <div
                    style="
                      width: 60px;
                      padding: 0 6px;
                      border-top: 1px solid #eeeeee;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    {{ item.text }}
                  </div>
                  <div v-if="item.data" class="tgq-table-column-1">
                    <div
                      v-for="(subItem, j) in item.data"
                      :key="j"
                      class="tgq-table-column-1-item"
                    >
                      <div style="padding: 0 6px">{{ subItem.text }}</div>
                      <div v-if="subItem.data" class="tgq-table-column-2">
                        <div
                          v-for="(thirdItem, k) in subItem.data"
                          :key="k"
                          class="tgq-table-column-2-item"
                        >
                          <div style="padding: 0 6px">{{ thirdItem.text }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tgq-notes">
                <div>{{ tgqDatas.note1 }}</div>
                <div>{{ tgqDatas.note2 }}</div>
                <div>{{ tgqDatas.note3 }}</div>
              </div>
            </div>
            <div v-else class="empty-data">暂无数据</div>
          </van-skeleton>
        </van-tab>
      </van-tabs>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'flights-refund-policy',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    baggageRuleInfos: {
      type: Object,
      default: null,
    },
    tgqInfos: {
      type: Object,
      default: null,
    },
    baggageParam: {
      type: String,
      default: '',
    },
    tgqParam: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baggageLoading: false,
      tgqLoading: false,
      baggageDatas: this.baggageRuleInfos,
      tgqDatas: null,
    };
  },
  computed: {
    visible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    visible: function(val) {
      if (val) {
        this.handleGeneratingData();
      }
    }
  },
  methods: {
    handleGeneratingData() {
      console.log('???????', this.value);
      if (this.baggageRuleInfos) {
        this.baggageDatas = this.baggageRuleInfos;
      } else {
        this.fetchBaggageRuleInfos();
      }
      if (this.tgqInfos) {
        this.tgqDatas = this.handleTgqDatas(this.tgqInfos);
      } else {
        this.fetchTgqInfos();
      }
    },
    fetchBaggageRuleInfos() {
      if (this.baggageParam && !this.baggageLoading) {
        this.baggageLoading = true;
        const formData = new FormData();
        formData.append('baggageParam', this.baggageParam);
        this.$API.flights
          .getTicketsBaggage(formData)
          .then((res) => {
            if (res.code < 300) {
              this.baggageDatas = res.data;
            }
          })
          .catch(console.log)
          .finally(() => {
            this.baggageLoading = false;
          });
      }
    },
    fetchTgqInfos() {
      if (this.tgqParam && !this.tgqLoading) {
        this.tgqLoading = true;
        const formData = new FormData();
        formData.append('tgqParam', this.tgqParam);
        this.$API.flights
          .getTicketsTgq(formData)
          .then((res) => {
            if (res.code < 300 && res.data) {
              this.tgqDatas = this.handleTgqDatas(res.data);
            }
          })
          .catch(console.log)
          .finally(() => {
            this.tgqLoading = false;
          });
      }
    },
    handleTgqDatas(result) {
      const tgqDatas = {
        note1: result.note1,
        note2: result.note2,
        note3: result.note3,
        data: [],
      };

      if (result.adult && result.adult.timePointCharges) {
        tgqDatas.data.push({
          text: '成人退改签说明',
          data: [
            {
              text: '退票手续费',
              data: result.adult.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.returnFee}/人`,
              })),
            },
            {
              text: '改签手续费',
              data: result.adult.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.changeFee}/人`,
              })),
            },
          ],
        });
      }

      if (result.child && result.child.timePointCharges) {
        tgqDatas.data.push({
          text: '儿童退改签说明',
          data: [
            {
              text: '退票手续费',
              data: result.child.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.returnFee}/人`,
              })),
            },
            {
              text: '改签手续费',
              data: result.child.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.changeFee}/人`,
              })),
            },
          ],
        });
      }

      if (result.infant && result.infant.timePointCharges) {
        tgqDatas.data.push({
          text: '婴儿退改签说明',
          data: [
            {
              text: '退票手续费',
              data: result.infant.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.returnFee}/人`,
              })),
            },
            {
              text: '改签手续费',
              data: result.infant.timePointCharges.map((item) => ({
                text: `${item.timeText}¥${item.changeFee}/人`,
              })),
            },
          ],
        });
      }

      return tgqDatas;
    },
  },
};
</script>

<style>
.policy-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.policy-content {
  height: calc(70vh - 70px);
  overflow-y: auto;
  padding: 0 0 20px 0;
}
.flight-baggage-item {
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 12px;
  line-height: 20px;
}

.flight-baggage-title {
  flex: 0 0 120px;
  font-weight: bold;
}
.flight-baggage-content {
  flex: 1 1 auto;
}
.tgq-table {
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
.tgq-table-body {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  font-size: 12px;
  border-left: 1px solid #eeeeee;
}
.tgq-table-column-1 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  border-left: 1px solid #eeeeee;
}
.tgq-table-column-1-item {
  display: flex;
  justify-content: stretch;
  align-items: center;
  border-top: 1px solid #eeeeee;
}
.tgq-table-column-2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  border-left: 1px solid #eeeeee;
}
.tgq-table-column-2-item {
  display: flex;
  justify-content: stretch;
  align-items: center;
  padding: 4px 0;
}
.tgq-notes {
  margin-top: 24px;
  font-size: 12px;
}
.tgq-notes > div {
  margin: 10px 0;
}
.empty-data {
  color: #999999;
  text-align: center;
  padding: 10px 0;
}
</style>
